module.exports = __webpack_public_path__ + "static/media/empty.ad810de7.svg";